import React from 'react';
import MiniHeader from '../components/MiniHeader';
import Team from '../components/Team';
import Contact from '../components/Contact';

const ContactUS = () => {
  return (
    <>
    <MiniHeader title={"Contact Us"} />
    <Contact />
    </>
  );
};

export default ContactUS;
